<template>
  <div class="modal-container">
    <div v-if="open" class="modal">
      <div role="document" @click.self="$emit('close')">
        <iframe class="letter-preview-content" :src="url" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open", "url"],
};
</script>

<style scoped>
.letter-preview-content {
  min-width: 1200px;
  min-height: 1000px;
  margin-top: 10%;
}

.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 4; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  color: #212529;
}

.modal-content {
  background-color: #fefefe;
  margin: 20% auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  max-width: 650px; /* Could be more or less, depending on screen size */
  box-shadow: 5px 5px 15px hsla(0, 0%, 0%, 0.4);
}
</style>